import { Confirmation } from 'core/components';
import { IConfirmation } from 'core/types';
import { ImportVendorQuoteForm } from 'quotes/components/';
import { IAttributeForm } from 'quotes/components/ExportSkuPart/types';
import { VendorQuoteAttachToType, VendorQuoteDuplicateOutcome } from 'quotes/enums';
import {
  IImportedQuoteData,
  IImportVendorQuoteForm,
  IVendorContactSignal,
  IVendorMappingSignal,
  IVendorQuote,
  IVendorQuoteNumberSignal,
  IVendorQuoteRevisionSignal,
} from 'quotes/types';

export type IImportVendorQuoteActionProps = {
  quote?: IVendorQuote;
  importedQuoteData: IImportedQuoteData;
  extractedImportId?: number | null;
  vendorContact?: IVendorContactSignal | null;
  vendorMapping?: IVendorMappingSignal | null;
  vendorQuoteNumber?: IVendorQuoteNumberSignal | null;
  vendorQuoteRevision?: IVendorQuoteRevisionSignal | null;
  isFinalizeFailed?: boolean;
  isOpenImportVendorQuoteForm: boolean;
  onCloseImportVendorQuoteForm: () => void;
  onImportVendorQuote: (data: IImportVendorQuoteForm, attributes?: IAttributeForm | null) => void;
  resolveVendorQuoteDuplicate: (
    data: IImportVendorQuoteForm
  ) => Promise<VendorQuoteDuplicateOutcome>;
  startVendorQuoteImport: (attributes?: IAttributeForm | null) => Promise<boolean | void>;
  confirmationOption: IConfirmation;
};

export const ImportVendorQuoteAction = ({
  quote,
  importedQuoteData,
  extractedImportId,
  vendorContact,
  vendorMapping,
  vendorQuoteNumber,
  vendorQuoteRevision,
  isFinalizeFailed,
  isOpenImportVendorQuoteForm,
  onCloseImportVendorQuoteForm,
  onImportVendorQuote,
  resolveVendorQuoteDuplicate,
  startVendorQuoteImport,
  confirmationOption,
}: IImportVendorQuoteActionProps) => {
  const defaultValues = {
    ...(quote && {
      project: {
        id: quote.customerProjectId,
        name: quote.customerProjectName,
      },
      contact: {
        id: quote.vendorCorporateUserId,
        name: quote.vendorCorporateUserName,
        companyName: quote.vendorContactGroupName,
      },
    }),
    attachTo: VendorQuoteAttachToType.JOB,
  };

  const hiddenFields = quote ? { attachTo: true } : null;

  return (
    <>
      <ImportVendorQuoteForm
        quote={quote}
        importedQuoteData={importedQuoteData}
        extractedImportId={extractedImportId}
        vendorContact={vendorContact}
        vendorMapping={vendorMapping}
        vendorQuoteNumber={vendorQuoteNumber}
        vendorQuoteRevision={vendorQuoteRevision}
        isFinalizeFailed={isFinalizeFailed}
        isOpen={isOpenImportVendorQuoteForm}
        onClose={onCloseImportVendorQuoteForm}
        onImport={onImportVendorQuote}
        onResolveDuplicate={resolveVendorQuoteDuplicate}
        onStartImport={startVendorQuoteImport}
        hiddenFields={hiddenFields}
        defaultValues={defaultValues}
        disabled={!!quote}
      />

      {confirmationOption && <Confirmation isOpen={true} {...confirmationOption} />}
    </>
  );
};
